import { risapi, getAxiosConfig, getAPIFullUrl, handleApiError } from './risapi';

export const getGames = async (filters, callback) => {
    try {
        const response = await risapi.get(getAPIFullUrl('/api/games', filters), getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const createGame = async (data, callback) => {
    try {
        // Game setup data is complex and is best sent as JSON
        const response = await risapi.post('/api/games', data, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const fetchGame = async (id, callback) => {
     try {
        const response = await risapi.get(`/api/games/${id}`, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};


export const updateGame = async (gameData, callback) => {
    try {
        const response = await risapi.put(`/api/games/${gameData.id}`, gameData, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

